module.exports = __webpack_public_path__ + "static/img/50-3.7d37dad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/50-3.jpg
// module id = KW+7
// module chunks = 0